export default "__VITE_ASSET__Beo4JNJu__"